import { AuthTypes } from '../constants/authConstants';
import axios from 'axios';

const savedUser = JSON.parse(localStorage.getItem('config.savedUser') || `{
    "token": null,
    "email": null,
    "id": null,
    "name": null,
    "color": null
}`);
savedUser.isOwner = false;
axios.defaults.headers.common['x-access-token'] = savedUser.token;

const initialState = savedUser;

export const authReducer = (state = initialState, action) => {
    switch (action.type) {
        case AuthTypes.LOGIN_AUTH:
            localStorage.setItem('config.savedUser', JSON.stringify(action.user));
            axios.defaults.headers.common['x-access-token'] = action.user.token;

            return {
                ...state,
                token: action.user.token,
                email: action.user.email,
                id: action.user.id,
                name: action.user.name,
                color: action.user.color
            };

        case AuthTypes.LOGOUT_AUTH:
            localStorage.removeItem('config.savedUser');
            axios.defaults.headers.common['x-access-token'] = null;

            return {
                ...state,
                token: null
            };

        case AuthTypes.AUTH_SET_OWNERSHIP:
            return {
                ...state,
                isOwner: action.isOwner
            };
        case 'RESET':
            return {
                ...state,
                isOwner: false
            };

        default:
            return state;
    }
};